/**
 * In-memory scroll position store.
 *
 * Keyed by a route-specific identifier (e.g. `dashboard:<id>`).
 * Survives client-side navigation; cleared on hard page reload.
 */

const store = new Map<string, number>();

export function getScroll(key: string): number {
  return store.get(key) ?? 0;
}

export function setScroll(key: string, value: number): void {
  store.set(key, value);
}